import React from 'react';
import { IStorefrontSection } from '../../../../models/Storefront';
import { useGetStorefrontBundlesQuery, useGetStorefrontFeaturedProductsQuery } from '../../../../store/endpoints/StorefrontProductEndpoints';
import { BundleCard, ProductCard } from './ProductCard';
import { PrimaryButton } from '@fluentui/react';

interface INoSectionsDisplayProps {
    editMode?: boolean;
    onSwitchToSections: (sections: IStorefrontSection[]) => void;
    storefrontId?: string;
    storefrontSubUrl?: string;
    isDark?: boolean;
}

const NoSectionsDisplay: React.FC<INoSectionsDisplayProps> = (props) => {
    const featured = useGetStorefrontFeaturedProductsQuery({ id: props.storefrontId ?? '', maxEntries: 6 }, { skip: !props.storefrontId });
    const bundles = useGetStorefrontBundlesQuery({ id: props.storefrontId ?? '', maxEntries: 6 }, { skip: !props.storefrontId });

    const defaultSections: IStorefrontSection[] = [
        {
            id: crypto.randomUUID(),
            title: 'Featured Products',
            type: 'featured',
            maxEntries: 6,
            isNew: true,
        },
        {
            id: crypto.randomUUID(),
            title: 'Bundles',
            type: 'bundles',
            maxEntries: 6,
            isNew: true,
        }
    ]

    return <div>
        <div className='storefront-product-card-container'>
            {featured.data?.items?.slice(0, 6).map((product) => (
                <ProductCard key={product.id} product={product} isDark={props.isDark} />
            ))}
        </div>
        <div className='storefront-product-card-container'>
            {bundles.data?.items?.slice(0, 6).map((bundle) => (
                <BundleCard key={bundle.id} bundle={bundle} isDark={props.isDark} />
            ))}
        </div>
        <div style={{textAlign: 'center', marginTop: '2em'}}>
        {props.editMode && <PrimaryButton
            text='Switch to Sections'
            onClick={() => props.onSwitchToSections(defaultSections)}
            style={{ width: '200px' }}
            />}
        </div>
    </div>

}

export default NoSectionsDisplay;